import { render } from "./MultiAuswahlComponent.vue?vue&type=template&id=537e35a2&scoped=true"
import script from "./MultiAuswahlComponent.vue?vue&type=script&lang=js"
export * from "./MultiAuswahlComponent.vue?vue&type=script&lang=js"

import "./MultiAuswahlComponent.vue?vue&type=style&index=0&id=537e35a2&scoped=true&lang=css"

import exportComponent from "/Users/cc/www/doit2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537e35a2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QCard,QCardSection,QInput,QCardActions});
